import { Clock, CardPos, Computing } from "iconsax-react";
import { CheckIcon } from "@/shared/assets/icons";
import type { ContractorPayrollAggregatedStatus, GPHPaymentStatus } from "../types";

interface StatusConfig {
  label: string;
  color: "info" | "notice" | "positive" | "negative";
  icon: React.ReactNode;
}

export const CONTRACTOR_PAYROLL_AGGREGATED_STATUS_MAP: Record<ContractorPayrollAggregatedStatus, StatusConfig> = {
  all_pending: {
    label: "status.all_pending",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  partially_approved: {
    label: "status.all_pending",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  all_approved: {
    label: "status.all_approved",
    color: "info",
    icon: <CardPos size={14} color="currentColor" />,
  },
  partially_paid: {
    label: "status.partially_paid",
    color: "notice",
    icon: <Computing size={14} color="currentColor" />,
  },
  all_paid: {
    label: "status.all_paid",
    color: "positive",
    icon: <CheckIcon />,
  },
};

export const GPH_PAYMENT_STATUS_MAP: Record<GPHPaymentStatus, StatusConfig> = {
  pending: {
    label: "payroll.detail.gphPayments.statusPending",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  approved: {
    label: "payroll.detail.gphPayments.statusApproved",
    color: "info",
    icon: <CardPos size={14} color="currentColor" />,
  },
  paid: {
    label: "payroll.detail.gphPayments.statusPaid",
    color: "positive",
    icon: <CheckIcon />,
  },
};
